export default "__VITE_ASSET__BYWI$Bwj__"